<template>
  <div class="task_intro">
    <div class="task_intro_inner">
      <div class="intro_left">
        <img
          class="intro_title"
          src="@/assets/image/module_title.png"
          alt="拯救生命"
        />
        <div class="intro_subtitle">修涞贵 著 · 一代制药巨擘的奋发之路</div>
        <div class="intro_text">
          <p>
            丈夫者，不屈不移不淫为正；实物者，不倾不斜不偏为正。正者，人与物之美称；正者，天地大千之致中和也。夫正，不生于天然，不得于随意，唯修者能趋正，近正而方正。
          </p>
          <p>
            生命之正为健康，生活之正为健旺，生存之正为健全。人生之正者，祛邪驱恶，积善行道，得大自在矣。
          </p>
          <p>
            修残补缺是谓修补，修真养气所谓修养，修德行善乃谓修行，修元正本方为修正。夫修为术而正为道。身不修则疲惫，路不修则崎岖，车不修则残破，驾不修则祸倾。所以然者，圣人修而三省吾身，学人修而悬梁刺股，僧人修而斋戒苦行，艺人修而废寝忘食！是以趋正之途唯修正可望，近正之境为修正可抵，方正之间为修正可达。
          </p>
        </div>
      </div>

      <div class="intro_right">
        <img
          class="intro_book"
          src="@/assets/image/book@2x.png"
          alt="《拯救生命》书籍"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TaskIntro",
};
</script>

<style lang="stylus" scoped>
$text-color = #333333
$font-medium = SourceHanSansCN-Medium, SourceHanSansCN, sans-serif
$font-regular = SourceHanSansCN-Regular, SourceHanSansCN, sans-serif

/* 设计稿基准宽度：1920px
 * 规则：小于 1920 时按 vw 等比缩放；超过 1920 时锁定设计稿 px 尺寸。
 * 这样各分辨率下换行位置、左右布局、图文比例完全一致。
 */
r(n)
  return unquote('min(' + n + 'px, ' + (n / 19.2) + 'vw)')

/* 负数（如负 margin）需要 max，保证宽屏时不会越缩越负 */
rn(n)
  return unquote('max(' + n + 'px, ' + (n / 19.2) + 'vw)')

.task_intro {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: r(635);
  padding: r(98) 0 r(92);
  background-image: url('../../../assets/image/module_bg@2x.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  margin-top: 60px;

  .task_intro_inner {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: r(1182);
    margin: 0 auto;
    padding: 0;
  }

  .intro_left {
    flex: 0 0 r(626);
    min-height: r(330);
  }

  .intro_title {
    display: block;
    width: r(300);
    height: r(60);
    margin-left: rn(-27);
  }

  .intro_subtitle {
    margin-top: r(3);
    color: $text-color;
    font-family: $font-medium;
    font-size: r(24);
    font-weight: 600;
    line-height: r(60);
  }

  .intro_text {
    margin-top: r(32);
    color: $text-color;
    font-family: $font-regular;
    font-size: r(16);
    font-weight: 400;
    line-height: r(26);
    text-align: justify;
    text-justify: inter-ideograph;

    p {
      margin: 0 0 r(36);

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .intro_right {
    flex: 0 0 r(554);
    margin-top: r(7);

    .intro_book {
      display: block;
      width: 100%;
      height: auto;

      /* 悬浮放大：用 transform 实现，不参与文档流，不影响页面布局 */
      transform-origin: center center;
      transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      will-change: transform;

      &:hover {
        transform: scale(1.0542);
      }
    }
  }
}
</style>
